import { useState } from 'react';
import { Box, Button, Chip, TextField, Typography } from '@mui/material';
import ThemeButton from 'shared/ui/Button';
import { smallFieldSx } from 'shared/config/Styles';
import { ITEM_COLUMNS } from '../../../lib/packingListFields';

const LOT_MAX_LENGTH = ITEM_COLUMNS.find((c) => c.field === 'lot_no').maxLength;

/**
 * LOT·유통기한은 표 밖 각주로 오는 경우가 많아 파싱이 거의 안 된다.
 * 한 번 입력해 전 라인에 적용하는 일괄 입력을 두고, 라인별 예외는 그리드 셀에서 고친다.
 */
export default function LotEntryField({ lines, onBatchApply }) {
    const [lot, setLot] = useState('');
    const [expiry, setExpiry] = useState('');
    const missing = lines.filter((l) => !l.lot_no).length;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography sx={{ fontSize: 12, fontWeight: 500, color: '#003a52' }}>LOT / Expiry batch entry</Typography>
                {missing > 0 ? <Chip size="small" variant="outlined" label={`${missing} line(s) without LOT`} sx={{ fontSize: 10, height: 18 }} /> : <Chip size="small" color="success" label="LOT set on every line" sx={{ fontSize: 10, height: 18 }} />}
            </Box>
            <Typography sx={{ fontSize: 11, color: 'text.secondary' }}>Enter the LOT number from the footnote once and apply it to every line. Edit single lines in the grid afterwards.</Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: 1, alignItems: 'center' }}>
                <TextField size="small" label="LOT No." value={lot} onChange={(e) => setLot(e.target.value)} inputProps={{ maxLength: LOT_MAX_LENGTH }} placeholder="e.g. RL260805, 20260716A" InputLabelProps={{ shrink: true }} sx={smallFieldSx} />
                <TextField size="small" type="date" label="Expiry date" value={expiry} onChange={(e) => setExpiry(e.target.value)} InputLabelProps={{ shrink: true }} sx={smallFieldSx} />
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <ThemeButton text="Apply to all lines" disabled={!lot.trim()} onClick={() => { onBatchApply(lot.trim(), expiry || null); setLot(''); setExpiry(''); }} sx={{ width: 'auto', px: 1.5 }} />
                    <Button size="small" variant="outlined" onClick={() => { setLot(''); setExpiry(''); }} sx={{ fontSize: 12, height: 27 }}>Clear</Button>
                </Box>
            </Box>
        </Box>
    );
}
